const styles = theme => ({
    wrapper: {
        position: 'fixed',
        bottom: 20,
        right: 50,
        '@media (min-width:381px) and (max-width:767px)': {
            right: 10,
            bottom: 10
        },
        '@media (max-width: 380px)': {
            right: 10,
            bottom: 10
        }
    },
    speedDial: {
        margin: '0 20%'
    },
    listItem: {
        color: theme.palette.secondary.dark
    }
});

export default styles;